import { render, staticRenderFns } from "./FabuEvaluate.vue?vue&type=template&id=34d00e52&scoped=true"
import script from "./FabuEvaluate.vue?vue&type=script&lang=js"
export * from "./FabuEvaluate.vue?vue&type=script&lang=js"
import style0 from "./FabuEvaluate.vue?vue&type=style&index=0&id=34d00e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d00e52",
  null
  
)

export default component.exports